import { intlLocale, t, tp } from '@/i18n/i18n';

/** «2 hours ago» · «yesterday» · «Aug 30» — как подписи в прототипе списка канвасов. */
export function formatRelative(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const diffMs = now.getTime() - date.getTime();
  const minutes = Math.round(diffMs / 60_000);
  if (minutes < 1) return t('time.justNow');
  if (minutes < 60) return t('time.minAgo', { n: minutes });
  const hours = Math.round(minutes / 60);
  if (hours < 24) return tp('time.hoursAgo', hours);
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startThat = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((startToday.getTime() - startThat.getTime()) / 86_400_000);
  if (days === 1) return t('time.yesterday');
  return formatShortDate(date, date.getFullYear() !== now.getFullYear());
}

/** «Aug 30» / «30 авг» (+ год при необходимости) через Intl по текущему языку. */
export function formatShortDate(date: Date, withYear = false): string {
  return new Intl.DateTimeFormat(intlLocale(), {
    month: 'short',
    day: 'numeric',
    ...(withYear ? { year: 'numeric' } : {}),
  }).format(date);
}

/** «in 23 days» · «today» · «expired» · «never» для срока ссылки шаринга. */
export function formatExpiry(iso: string | null, now: Date = new Date()): string {
  if (!iso) return t('time.never');
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  if (date.getTime() < now.getTime()) return t('time.expired');
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startThat = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((startThat.getTime() - startToday.getTime()) / 86_400_000);
  if (days <= 0) return t('time.today');
  return tp('time.inDays', days);
}
